// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b0af6413","453":"86742b18","644":"a7836591","732":"7f9c1551"}[chunkId] + ".chunk.js";
};